import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import {
    HarvestEventHarvestPickTypeId,
    HarvestEventsProps
} from 'services/harvestEvents/types';

// Global Components
import PickTypeExternalIdValue from 'components/PickTypeExternalIdValue';

// Global Selectors
import {
    makeSelectHarvestEventHarvestPickTypeId,
    makeSelectHarvestEventPickTypeExternalId
} from 'services/harvestEvents/selectors';

type OwnProps = HarvestEventsProps;

interface ConnectedProps {
    pickTypeId: HarvestEventHarvestPickTypeId;
    pickTypeExternalId?: string | null;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventPickTypeExternalIdValue extends React.PureComponent<
    Props
> {
    render(): string | React.ReactElement | null {
        const { pickTypeId, pickTypeExternalId } = this.props;
        if (pickTypeExternalId) {
            return pickTypeExternalId;
        }
        if (pickTypeId) {
            return <PickTypeExternalIdValue pickTypeId={pickTypeId} />;
        }
        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    pickTypeId: makeSelectHarvestEventHarvestPickTypeId(),
    pickTypeExternalId: makeSelectHarvestEventPickTypeExternalId()
});

export default connect(mapStateToProps)(HarvestEventPickTypeExternalIdValue);
